<template>
  <div class="video-play">
    <!--    视频预览-->
    <div id="divPlugin" class="divPlugin"/>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  components: {},
  props: {
    hkOptions: {
      type: Object
    },
    showMessage: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      webVideo: '',
      messageFun: null,
      hkvInfo: {
        ip: '114.242.16.189',//海康威视摄像头/硬盘录像机的ip地址
        port: '63450',//海康威视摄像头/硬盘录像机的端口
        iWSPort: '32761',//海康威视摄像头/ws端口号
        username: 'admin',//海康威视摄像头/硬盘录像机的用户名
        password: 'lly88498807',//海康威视摄像头/硬盘录像机的密码
        rtspUrl: '' // 有值使用rtspUrl播放
      },
      szDeviceIdentify: '',
      g_iWndIndex: 0,
      channels: [],
      deviceport: '',
      rtspPort: '',
      divPluginShow:false,
      autoRealPlay: false,
      iWndowType: 1
    }
  },
  created() {
  },
  mounted() {
    this.hkOptions.type === 1 && this.init()
  },
  methods: {
    changeWndNum (iType) {
      this.iWndowType =iType
      iType = parseInt(iType, 10);
      WebVideoCtrl.I_ChangeWndNum(iType);
    },
    init(autoPlay = true) {
      let _this = this
      this.divPluginShow = true
      this.hkvInfo = this.hkOptions
      this.autoRealPlay = autoPlay
      // 初始化插件参数及插入插件
      WebVideoCtrl.I_InitPlugin({
        bWndFull: true,     //是否支持单窗口双击全屏，默认支持 true:支持 false:不支持
        iWndowType: this.iWndowType,
        cbSelWnd: (xmlDoc) => {
          this.g_iWndIndex = parseInt($(xmlDoc).find("SelectWnd").eq(0).text(), 10);
          var szInfo = "当前选择的窗口编号：" + this.g_iWndIndex;
          console.log(szInfo);
        },
        cbDoubleClickWnd: function (iWndIndex, bFullScreen) {
          var szInfo = "当前放大的窗口编号：" + iWndIndex;
          if (!bFullScreen) {
            szInfo = "当前还原的窗口编号：" + iWndIndex;
          }
          console.log(szInfo);
        },
        cbEvent: function (iEventType, iParam1, iParam2) {
          if (2 == iEventType) {// 回放正常结束
            console.log("窗口" + iParam1 + "回放结束！");
          } else if (-1 == iEventType) {
            console.log("设备" + iParam1 + "网络错误！");
          }
          // else if (3001 == iEventType) {
          //   clickStopRecord(g_szRecordType, iParam1);
          // }
        },
        cbInitPluginComplete: () => {
          WebVideoCtrl.I_InsertOBJECTPlugin("divPlugin").then(() => {
            // 检查插件是否最新
            WebVideoCtrl.I_CheckPluginVersion().then((bFlag) => {
              if (bFlag) {
                _this.huandleMessage(true, '检测到新的插件版本，请安装升级！', 'error', 3000)
                _this.runInstaller();
              }
              _this.changeWndNum(_this.iWndowType)
              _this.login()
            });
          }, () => {
            _this.huandleMessage(true, '插件初始化失败，请先安装', 'error', 3000)
            _this.runInstaller();
          });
        }
      });
    },
//     安装插件
    runInstaller() {
      // 在这里执行运行安装程序的逻辑
      window.location.href = 'static/Hkjs/codebase/HCWebSDKPlugin.exe';
    },
// 登录
    login(hkvInfo) {
      let _this = this
      // _this.huandleMessage(true, '登陆中请勿操作页面!', 'info', 0)
      let data = hkvInfo || this.hkvInfo
      if ("" === data.ip || "" === data.port) {
        return;
      }
      this.szDeviceIdentify = data.ip + "_" + data.port;
      console.log('设备信息:' + data.ip, data.port, data.username, data.password, data.rtspUrl)
      WebVideoCtrl.I_Login(data.ip, 2, data.port, data.username, data.password, {
        success: (xmlDoc) => {
          _this.autoRealPlay && this.clickStartRealPlay()
        },
        error: function (status, xmlDoc) {
          console.error('设备异常------', status)
          _this.huandleMessage(true, '设备异常', 'error', 3000)
        }
      });
    },
    fullScreen () {
      WebVideoCtrl.I_FullScreen(true)
    },
    // 开始预览
    clickStartRealPlay(rtspUrl) {
      const _this = this;
      if (this.showMessage) {
        this.huandleMessage(true, '视频加载中请勿操作页面!', 'info', 10000)
      }
      // 获取播放窗口信息
      const oWndInfo = WebVideoCtrl.I_GetWindowStatus(this.g_iWndIndex)
      if (null == this.szDeviceIdentify) {
        return;
      }
      const startRealPlay = () => {
        if (_this.hkvInfo.rtspUrl || rtspUrl) {
          try {
            let params = {}
            if (rtspUrl) {
              params.szUrl = rtspUrl
              // params.startTime = '20240821T170810Z'
              // params.szEndTime = '20240821T173914Z'
            } else {
              params.szUrl = _this.hkvInfo.rtspUrl
            }
            console.log(params, 'params')
            WebVideoCtrl.I_StartPlay(this.szDeviceIdentify, params)
          } catch (e) {
            _this.huandleMessage(true, '预览rtsp链接失败请检查设备配置', 'error', 3000)
            _this.destroyPlugin()
          }
        } else {
          WebVideoCtrl.I_StartRealPlay(this.szDeviceIdentify, {
            // iWSPort: data.iWSPort, // 设置webScoket地址
            success: function () {
              _this.huandleMessage(true, '预览成功', 'success', 3000)
            },
            error: function (status, xmlDoc) {
              if (403 === status) {
                console.log('设备不支持Websocket取流')
              } else {
                _this.huandleMessage(true, '预览失败请检查设备配置', 'error', 3000)
                _this.destroyPlugin()
              }
            }
          });
        }
      };

      if (oWndInfo != null) {// 已经在播放了，先停止
        WebVideoCtrl.I_Stop({
          success: function () {
            startRealPlay();
          }
        });
      } else {
        startRealPlay();
      }
    },
    // 加速播放
    playFast() {
      const _this = this;
      WebVideoCtrl.I_PlayFast({
        success: function () {
          _this.huandleMessage(true, '加速成功', 'success', 3000)
        },
        error: function (status, xmlDoc) {
          console.log(status, xmlDoc)
        }
      });
    },
    // 减速播放
    playSlow() {
      const _this = this;
      WebVideoCtrl.I_PlaySlow({
        success: function () {
          _this.huandleMessage(true, '减速播放', 'success', 3000)
        },
        error: function (status, xmlDoc) {
          console.log(status, xmlDoc)
        }
      });
    },
    // 暂停播放
    pause() {
      const _this = this;
      WebVideoCtrl.I_Pause({
        success: function () {
          _this.huandleMessage(true, '暂停播放', 'success', 3000)
        },
        error: function (status, xmlDoc) {
          console.log(status, xmlDoc)
        }
      });
    },
    // 恢复播放
    resume() {
      const _this = this;
      WebVideoCtrl.I_Resume({
        success: function () {
          _this.huandleMessage(true, '恢复播放', 'success', 3000)
        },
        error: function (status, xmlDoc) {
          console.log(status, xmlDoc)
        }
      });
    },
    //     处理消息提示
    huandleMessage(showClose, message, type, duration) {
      this.messageFun ? this.messageFun.close() : '';
      this.messageFun = this.$message({
        showClose,
        message,
        type,
        duration
      });
    },
// 获取通道
    getChannelInfo() {
      let self = this
      this.channels = []
      if (null === this.szDeviceIdentify) {
        return;
      }
      // 模拟通道
      WebVideoCtrl.I_GetAnalogChannelInfo(this.szDeviceIdentify, {
        async: false,
        success: function (xmlDoc) {
          let oChannels = $(xmlDoc).find("VideoInputChannel");
          $.each(oChannels, function (i) {
            let id = $(this).find("id").eq(0).text(),
              name = $(this).find("name").eq(0).text();
            if ("" === name) {
              name = "Camera " + (i < 9 ? "0" + (i + 1) : (i + 1));
            }
            this.channels.push({
              id: id,
              name: name
            })
          });
        },
        error: function (status, xmlDoc) {
          console.log('获取模拟通道号失败')
        }
      });
    },
// 获取端口
    getDevicePort() {
      let self = this
      if (null == this.szDeviceIdentify) {
        return;
      }
      let oPort = WebVideoCtrl.I_GetDevicePort(this.szDeviceIdentify);
      if (oPort != null) {
        this.deviceport = oPort.iDevicePort;
        this.rtspPort = oPort.iRtspPort;
      }
    },
// 停止预览
    clickStopRealPlay() {
      let self = this
      let oWndInfo = WebVideoCtrl.I_GetWindowStatus(this.g_iWndIndex)
      if (oWndInfo != null) {
        WebVideoCtrl.I_Stop({
          success: function () {
          },
          error: function () {
            console.log('停止预览失败')
          }
        });
      }
    },
    stop() {
      let self = this
      let oWndInfo = WebVideoCtrl.I_GetWindowStatus(this.g_iWndIndex)
      if (oWndInfo != null) {
        WebVideoCtrl.I_Stop({
          success: function () {
          },
          error: function () {
            console.log('停止预览失败')
          }
        });
      }
    },
    // 销毁播放器
    destroyPlugin() {
      let self = this
      console.log('销毁播放器')
      WebVideoCtrl.I_DestroyPlugin({
        success: function () {
        },
        error: function () {
          console.log('销毁播放器失败')
        }
      });
    },
// 退出
    clickLogout() {
      this.channels = []
      this.destroyPlugin()
      if (null == this.szDeviceIdentify) {
        return;
      }
      WebVideoCtrl.I_Logout(this.szDeviceIdentify).then(() => {
        // 停止预览
        this.clickStopRealPlay()
        this.divPluginShow =false
      }, () => {
        console.log('退出失败===')
      });

    }
  },
}
</script>
<style lang="less" scoped>
.video-play {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .divPlugin{
    width: 100%;
    height: 100%;
  }

}

</style>
<style>
.play-window{
  border: 1px transparent solid !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HKvideo.vue